import React, { useEffect, useState } from 'react'
import bride from '../../assests/bride.mp4';
import groom from '../../assests/groom.mp4';
import draw from '../../assests/draw.mp4';
import homepage from '../../assests/homepage.svg';
import API_URL from '../../Config';

const Questionone = () => {

  const [winner, setWinner] = useState("");
  // const [question, setQuestion] = useState(null);

  useEffect(() => {
    getdata();
  }, []);

  const getdata = async () => {
    const requestOptions = {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    }

    fetch(`${API_URL}/api/getpollwinner`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        // setQuestion(data?.data[0]?.question);
        setWinner(data?.data[0]?.winner);
      });
  }

  console.log(winner);

  return (
    <div>

{winner === "rutuja" ?
      <video 
        src={bride} 
        autoPlay 
        // muted 
        // loop 
        className="fullscreen-video"
      />
      : 
      winner === "jinesh" ?
      <video 
        src={groom} 
        autoPlay 
        // muted 
        // loop 
        className="fullscreen-video"
      />
      : winner === "Draw" ?
      <video 
        src={draw} 
        autoPlay 
        // muted 
        // loop 
        className="fullscreen-video"
      />
      :
      <div className="homepage">
      <img src={homepage} alt="homepage" className="homepage-image" />
      </div>
      }


    </div>
  )
}

export default Questionone